module.exports = __webpack_public_path__ + "img/logo_solarium.9575fb70.jpg";